import { Box, Container, Divider, Typography } from "@mui/material";
import React from "react";
import { SPColor } from "../../constants/color";
import { useStyles } from "./styles";
import SpLogo from "../../assets/images/sp-logo.png";

export default function Footer() {
  const classes = useStyles;

  return (
    <Box
      sx={{
        backgroundColor: SPColor.BLACK,
        paddingY: 4,
        textAlign: "center",
        width: "100%",
        marginTop: 3,
      }}
    >
      <Container maxWidth="xl">
        <Divider
          sx={{
            height: "1px",
            backgroundColor: SPColor.WHITE,
            width: "90%",
            margin: "auto",
          }}
        />
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          paddingX={4}
          marginTop={3}
        >
          <Box>
            <a
              href="https://www.speakingpal.com"
              style={{ display: "flex", alignItems: "center" }}
              target="_blank"
            >
              <img src={SpLogo} alt="speakingpal logo" height="45" />
              <Typography color={SPColor.WHITE} mx={2} fontSize={"1.2rem"}>
                לדף הבית
              </Typography>
            </a>
          </Box>
          <Box>
            <Typography
              color={SPColor.WHITE}
              component="h5"
              variant="h5"
              sx={{ fontSize: "1rem" }}
            >
              כל הזכויות שמורות © 2023 SpeakingPal
            </Typography>
          </Box>
          <Box></Box>
        </Box>
      </Container>
    </Box>
  );
}
